import * as React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';

const Demo = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function ForSaleItemView() {
  let history = useHistory();
  const { item } = history.location.state;
  const [loading, setLoading] = React.useState([]);
  const [images, setImages] = React.useState();
  const [filteredImages, setFilteredImages] = React.useState([]);

  React.useEffect(() => {
    setLoading(true);
    loadImages();
  }, []);

  const loadImages = async () => {
    try {
      const images = await importAll(
        require.context('../assets/images/for_sale')
      );
      setImages(images);
      await getItemPhotos(images);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const importAll = async (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const getItemPhotos = async (images) => {
    const filtered =
      images &&
      Object.keys(images).filter((x) => {
        if (x.toLowerCase().includes(item?.pic_name.toLowerCase())) return x;
      });
    setFilteredImages(filtered);
  };

  if (!loading) {
    return (
      <Container style={{ paddingTop: 75 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8}>
            <Carousel dynamicHeight='100%' infiniteLoop>
              {filteredImages &&
                filteredImages.map((image, idx) => {
                  return (
                    <div key={idx}>
                      <img key={idx} src={images[image].default} alt={image} />
                    </div>
                  );
                })}
            </Carousel>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography
                  sx={{ mt: 4, mb: 2, fontSize: 50 }}
                  variant='primary'
                  component='div'
                  align='center'
                >
                  {item.name}
                </Typography>
                <Typography
                  sx={{ mt: 4, mb: 2 }}
                  variant='primary'
                  component='h6'
                  align='center'
                >
                  ${item.price}
                </Typography>
                <Typography
                  sx={{ m: 2 }}
                  variant='primary'
                  component='p'
                  align='center'
                >
                  {item.description}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Demo style={{ marginLeft: 0 }}>
                  {JSON.parse(item.color).map((x, idx) => {
                    return (
                      <Chip
                        key={idx}
                        label={x}
                        sx={{
                          m: 0.5,
                          color:
                            x === 'white' ||
                            x === 'grey' ||
                            x === 'silver' ||
                            x === 'yellow' ||
                            x === 'gold'
                              ? 'black'
                              : 'white',
                          backgroundColor: x === 'white' ? 'lightgrey' : x,
                        }}
                      />
                    );
                  })}
                  <List dense={false}>
                    <ListItem>
                      <ListItemText
                        primary={
                          item.type === 'wreath' ? item.size + '"' : item.size
                        }
                        secondary={'Size'}
                      />
                    </ListItem>
                    {item.type === 'wreath' && (
                      <ListItem>
                        <ListItemText
                          primary={item.theme?.toUpperCase()}
                          secondary={'Theme'}
                        />
                      </ListItem>
                    )}
                    {item.type === 'canvas' && (
                      <React.Fragment>
                        <ListItem>
                          <ListItemText
                            primary={item.texture?.toUpperCase()}
                            secondary={'Texture'}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemText
                            primary={item.top_coat?.toUpperCase()}
                            secondary={'Top Coat'}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemText
                            primary={!item.pieces ? '1' : item.pieces}
                            secondary={'Piece(s)'}
                          />
                        </ListItem>
                        {item.shipping && (
                          <ListItem>
                            <ListItemText
                              primary={`$${parseInt(item.shipping).toFixed(2)}`}
                              secondary={'Shipping'}
                            />
                          </ListItem>
                        )}
                      </React.Fragment>
                    )}
                  </List>
                </Demo>
              </Grid>
              <Container align='center'>
                <Button
                  size='large'
                  variant={'contained'}
                  onClick={() => {
                    history.push(`/checkout/${item.id}`);
                  }}
                >
                  BUY NOW
                </Button>
              </Container>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    );
  } else {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    );
  }
}
